export default {
  options: state => state.options,
};
